import { VoteOption } from '../../hooks/useVoting'

interface VoteButtonProps {
  emoji: string
  label: string
  option: VoteOption
  onClick: (option: VoteOption) => void
  disabled?: boolean
  isSelected?: boolean
}

export default function VoteButton({
  emoji,
  label,
  option,
  onClick,
  disabled = false,
  isSelected = false,
}: VoteButtonProps) {
  // Determine variant based on option
  const isBullish = option === VoteOption.Positive

  // Dynamic classes based on variant
  const baseClasses = "relative flex flex-col items-center justify-center p-4 rounded-2xl border transition-all duration-300 w-full"
  const activeClasses = isBullish
    ? "bg-gradient-to-br from-emerald-500/10 to-teal-500/10 border-emerald-500/50 shadow-[0_0_15px_rgba(52,211,153,0.3)]"
    : "bg-gradient-to-br from-rose-500/10 to-orange-500/10 border-rose-500/50 shadow-[0_0_15px_rgba(251,113,133,0.3)]"

  const inactiveClasses = isBullish
    ? "bg-gradient-to-br from-emerald-500/5 to-teal-500/5 border-emerald-500/20 hover:border-emerald-500/50 hover:from-emerald-500/10 hover:to-teal-500/10"
    : "bg-gradient-to-br from-rose-500/5 to-orange-500/5 border-rose-500/20 hover:border-rose-500/50 hover:from-rose-500/10 hover:to-orange-500/10"

  const textClass = isBullish ? "text-emerald-400" : "text-rose-400"

  return (
    <button
      onClick={() => onClick(option)}
      disabled={disabled}
      className={`
        ${baseClasses}
        ${isSelected ? activeClasses : inactiveClasses}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:scale-[1.02]'}
        h-32 group
      `}
    >
      <div className={`text-4xl mb-3 ${!disabled && 'animate-float'} transition-transform duration-300 group-hover:scale-110`}>
        {emoji}
      </div>
      <span className={`font-bold ${textClass}`}>{label}</span>

      {/* Selection Indicator Overlay */}
      {isSelected && (
        <div className={`absolute inset-0 rounded-2xl ${isBullish ? 'bg-emerald-500/5' : 'bg-rose-500/5'} animate-pulse`} />
      )}
    </button>
  )
}



